import * as httpRequest from '../commons/httpRequest';

async function getTmaStatus(localTmaUrl: string) {
    return await httpRequest.get<{ fsmState: 'Ready' | 'Stopping' | 'Developing' }>(`${localTmaUrl}/api/status`);
}

export async function getDeviceStatusFromTma(localTmaUrl: string, deviceUdid: string) {
    return await httpRequest.get<{ isVirtual: boolean }>(`${localTmaUrl}/api/devices/${deviceUdid}/status`);
}

export async function checkIfTmaIsReady(localTmaUrl: string) {
    const tmaStatus = await getTmaStatus(localTmaUrl);

    if (tmaStatus.fsmState !== 'Ready') {
        throw new Error('TMA is not ready');
    }
}
